<span class="permissions-title gea-font-heading-24">Permissions</span>

<div class="permissions-card">
  @if (isLoading) {
    <!-- Skeleton: 3 accordion panels -->
    @for (panel of [1, 2, 3]; track panel) {
      <div class="skeleton-panel">
        <div class="skeleton-panel-header">
          <p-skeleton width="6rem" height="1.25rem" borderRadius="0.25rem" />
          <p-skeleton width="1.5rem" height="1.5rem" borderRadius="0.25rem" />
        </div>
      </div>
    }
  } @else {
    <p-accordion [multiple]="true" [value]="[0]">
      @for (facility of facilities; track facility.facility; let i = $index) {
        <p-accordion-panel [value]="i">
          <p-accordion-header>
            <span class="gea-font-heading-20">{{ facility.facility }}</span>
          </p-accordion-header>
          <p-accordion-content>
            <!-- Column header row -->
            <div class="product-row product-row--header">
              <span class="gea-font-heading-16">Product Type</span>
              @for (col of columns; track col) {
                <span class="column-header gea-font-heading-16">
                  <i [class]="col === 'Technical' ? 'pi pi-lock' : 'pi pi-tag'"></i>
                  {{ col }}
                </span>
              }
            </div>

            <!-- Product rows -->
            @for (product of facility.products; track product.id) {
              <div class="product-row">
                <div class="product-name">
                  <span class="gea-font-heading-16">{{ product.displayName }}</span>
                  <span class="gea-font-body-14">{{ product.id }}</span>
                </div>
                @for (col of columns; track col) {
                  <p-inputNumber
                    [ngModel]="product.currentLevels[col]"
                    [showButtons]="true"
                    [min]="0"
                    [max]="getMax(product, col)"
                    [prefix]="'Level '"
                    [class.input-invalid]="isInvalid(facility.facility, product.id, col)"
                    [pt]="{
                      decrementButton: { class: product.currentLevels[col] <= 0 ? 'btn-disabled' : '' },
                      incrementButton: { class: product.currentLevels[col] >= getMax(product, col) ? 'btn-disabled' : '' }
                    }"
                    (ngModelChange)="onLevelChange(facility.facility, product.id, col, $event)"
                    inputStyleClass="gea-font-heading-16"
                    buttonLayout="horizontal"
                    decrementButtonIcon="pi pi-minus"
                    incrementButtonIcon="pi pi-plus" />
                }
              </div>
            }
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }
</div>
